import { useState } from "react";
import MyTabs from "src/components/layout/MyTabs/MyTabs";
import { Tab } from "@mui/material";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import { useStatData } from "src/context/StatContext";
import ReportDailyCore from "./Report/ReportDailyCore";
import ReportMonthlyCore from "./Report/ReportMonthlyCore";
import { DayIcon, MonthIcon } from "src/components/icons/ReportIcons";
import { TabPanel } from "src/components/js/Statics";

export default function StatBase() {
  const { isLoading } = useStatData();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => setTabValue(newValue);

  return (
    <div>
      <div className="noPrint">
        <MyTabs value={tabValue} onChange={handleTabChange} centered>
          <Tab
            key={0}
            label={
              <div className="tab">
                <DayIcon /> Päivittäiset
              </div>
            }
          />
          <Tab
            key={1}
            label={
              <div className="tab">
                <MonthIcon /> Kuukausittaiset
              </div>
            }
          />
        </MyTabs>
        {isLoading && <ProgressBar show={isLoading} height={3} />}
      </div>
      <TabPanel value={tabValue} index={0}>
        <ReportDailyCore />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <ReportMonthlyCore />
      </TabPanel>
    </div>
  );
}
